<template>
    <section
        class="how-we-working-component"
        :class="{ 'mobile-view' : isMobileView}">
        <h2 class="title">Как мы работаем</h2>
        <div class="steps-wrap">
            <div class="step">
                <picture class="work-icon">
                    <source srcset="/img/contact-work-step1.webp, /img/contact-work-step1@2x.webp 2x" type="image/webp">
                    <source srcset="/img/contact-work-step1.png, /img/contact-work-step1@2x.png 2x" type="image/png">
                    <img src="/img/contact-work-step1.png" alt="" loading="lazy" class="work-icon" width="120" height="120">
                </picture>
                <p class="description">{{ textStepOne }}</p>
            </div>
            <div class="step step-bottom">
                <picture class="work-icon">
                    <source srcset="/img/contact-work-step2.webp, /img/contact-work-step2@2x.webp 2x" type="image/webp">
                    <source srcset="/img/contact-work-step2.png, /img/contact-work-step2@2x.png 2x" type="image/png">
                    <img src="/img/contact-work-step2.png" alt="" loading="lazy" class="work-icon" width="120" height="120">
                </picture>
                <p class="description">{{ textStepTwo }}</p>
            </div>
            <div class="step">
                <picture class="work-icon">
                    <source srcset="/img/contact-work-step3.webp, /img/contact-work-step3@2x.webp 2x" type="image/webp">
                    <source srcset="/img/contact-work-step3.png, /img/contact-work-step3@2x.png 2x" type="image/png">
                    <img src="/img/contact-work-step3.png" alt="" loading="lazy" class="work-icon" width="120" height="120">
                </picture>
                <p class="description">{{ textStepThree }}</p>
            </div>
            <div class="step step-bottom">
                <picture class="work-icon">
                    <source srcset="/img/contact-work-step4.webp, /img/contact-work-step4@2x.webp 2x" type="image/webp">
                    <source srcset="/img/contact-work-step4.png, /img/contact-work-step4@2x.png 2x" type="image/png">
                    <img src="/img/contact-work-step4.png" alt="" loading="lazy" class="work-icon" width="120" height="120">
                </picture>
                <p class="description wide">{{ textStepFour }}</p>
            </div>
            <div class="step">
                <picture class="work-icon">
                    <source srcset="/img/contact-work-step5.webp, /img/contact-work-step5@2x.webp 2x" type="image/webp">
                    <source srcset="/img/contact-work-step5.png, /img/contact-work-step5@2x.png 2x" type="image/png">
                    <img src="/img/contact-work-step5.png" alt="" loading="lazy" class="work-icon" width="120" height="120">
                </picture>
                <p class="description">{{ textStepFive }}</p>
            </div>
        </div>

        <slot></slot>
    </section>
</template>

<script>
export default {
    name: 'Explanation',

    props: {
        isMobileView: {
            type: Boolean,
            default: false
        },

        textStepOne: {
            type: String,
            default: 'Звонок, \nрегистрация, заказ'
        },

        textStepTwo: {
            type: String,
            default: 'Консультация'
        },

        textStepThree: {
            type: String,
            default: 'Оплата заказа, загрузка документов'
        },

        textStepFour: {
            type: String,
            default: 'Проверка документов, заполнение и отправка декларации'
        },

        textStepFive: {
            type: String,
            default: 'Поступление денег \nот ФНС'
        }
    }
}
</script>